module.exports = __webpack_public_path__ + "static/media/chola.de457806.png";